import React from 'react';
import PropTypes from 'prop-types';
import { ButtonToolbar } from 'reactstrap';
import EditViewButton from './EditViewButton';
import DeleteViewButton from './DeleteViewButton';

const ViewToolbar = ({ viewId }) => (
  <ButtonToolbar className="pull-right">
    <div>
      <EditViewButton viewId={viewId} />{' '}
      <DeleteViewButton viewId={viewId} />
    </div>
  </ButtonToolbar>
);

ViewToolbar.propTypes = {
  viewId: PropTypes.number.isRequired,
};

export default ViewToolbar;